/**
 * Что считать «стартом» приложения для стартовых окон.
 *
 * Telegram не перезагружает свёрнутый Mini App: человек может вернуться через
 * сутки в тот же WebView. Холодный маунт — всегда старт; возврат из фона —
 * старт, если приложение было в фоне дольше STARTUP_RETURN_GAP_MS.
 * Сравниваем метки времени, а не считаем тики: в bfcache таймеры стоят.
 */
export const STARTUP_RETURN_GAP_MS = 30 * 60_000

export function shouldTreatForegroundAsStart(lastSeenAt: number | null, now: number): boolean {
  if (lastSeenAt == null) return false
  return now - lastSeenAt >= STARTUP_RETURN_GAP_MS
}
